import { API_BASE_URL, apiGet, apiPost } from '@/api/http';

import type { Skill } from '@/types/reference';

export const getSkillsList = () => apiGet<Skill[]>(`${API_BASE_URL}skills/`);

export const createNewSkill = (newSkill: string) =>
  apiPost<Skill>(`${API_BASE_URL}skills/`, { name: newSkill });
